import { render } from "./scripts.vue?vue&type=template&id=5524376a"
import script from "./scripts.vue?vue&type=script&lang=js"
export * from "./scripts.vue?vue&type=script&lang=js"

import "./scripts.vue?vue&type=style&index=0&id=5524376a&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__